import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import { Button, Col, Row } from 'antd';
import { errorNotification } from '../../../utils/notification-helpers';
// import { NONE } from './form-constants';

const styles = {
  btn: {
    width: '125px',
  },
};

const shouldNavigateOnTheAdditionalPage = (path, userAnswer) =>
  path && userAnswer === true;

// const shouldNavigateOnTheRecommendedGreenPage = (path, formValues) => {
//   const fieldNamesToCheck = [
//     'symptoms',
//     'additionalSymptoms',
//     'hadAFeverInTheLast14Days',
//     'hadAContinuousCoughInTheLast14Days',
//     'hadALossInTasteAndSmellInTheLast14Days',
//     'travel'
//   ];

//   return (
//     path &&
//     Object.entries(formValues).every(([key, value]) => {
//       if (fieldNamesToCheck.includes(key)) {
//         if (Array.isArray(value)) {
//           return value[0] === NONE;
//         }
//         return value === false;
//       }
//       return true;
//     })
//   );
// };

function MobileMentalQuestionsNavBtn({
  isSubmit,
  fieldName,
  isLastQuestion,
  currentValues,
  navBttonText,
  section,
  isSurveyCompleted,
  isInstructionPage,
  prevRoutePath,
  nextRoutePath,
  additionalRoute,
  // recommendedRoute,
}) {
  const { t } = useTranslation();
  const history = useHistory();

  const { values, submitForm } = useFormikContext();
  // console.log('values', values);

  const value = values[fieldName];

  const onPrev = () => {
    history.push(prevRoutePath);
  };

  const onNext = () => {
    if (isLastQuestion && !shouldNavigateOnTheAdditionalPage(additionalRoute, value)) {
      submitForm();
    } else if (shouldNavigateOnTheAdditionalPage(additionalRoute, value)) {
      history.push(additionalRoute);
    } else if (section && currentValues[section]) {
      const isNotValid = Object.values(currentValues[section]).includes("");
      if (!isNotValid) {
        history.push(nextRoutePath);
      } else {
        errorNotification(t('common:form.error.allFieldsAreRequired'));
      }
    } else if (isInstructionPage || isSurveyCompleted)
      history.push(nextRoutePath);

  };
  let isDisabled = true;
  if (Array.isArray(value)) {
    isDisabled = value.length;
  } else if (typeof value === 'string') {
    isDisabled = value;
  } else if (typeof value === 'number') {
    isDisabled = value >= 0;
  } else if (typeof value === 'boolean') {
    isDisabled = true
  }
  else if (typeof value === 'object' && value){
    if(!value.city || !value.country){
      isDisabled = false
    }
  }

  return (
    !isSurveyCompleted ? (
      <Row gutter={16} justify="space-between">
        {
          (!isSubmit && !isInstructionPage && !isSurveyCompleted) && (
            <>
              <Col>
                <Button style={styles.btn} size="large" onClick={onPrev}>
                {t('common:button.previous')}
                </Button>
              </Col>
              <Col>
                <Button
                style={styles.btn}
                size="large"
                type="primary"
                disabled={!isDisabled}
                onClick={onNext}
                >
                  {t('common:button.next')}
                </Button>
              </Col>
            </>
          )
        }
          {
              (isSubmit && !isSurveyCompleted) ? <Button
              style={{
                flexGrow: 1
              }}
              size="large"
              type="primary"
              disabled={!isDisabled}
              onClick={onNext}
              >
                {t('common:button.submitAnswers')}
              </Button> : null
          }
          {
            (isInstructionPage && navBttonText && !isSurveyCompleted) ? <Button
              size="large"
              type="primary"
              style={{
                flexGrow: navBttonText === "Proceed" ? 1 : 0,
                margin: "auto"
              }}
              disabled={!isDisabled}
              onClick={onNext}
              >
                {t(navBttonText)}
              </Button> : null
          }
      </Row>
    ) : (
      <>
        <Button
          style={{
            display: "block",
            width: "100%",
            marginBottom: "15px"
          }}
          size="large"
          type="primary"
          disabled={!isDisabled}
          onClick={() =>
            window.open("https://www.who.int/news-room/feature-stories/mental-well-being-resources-for-the-public", "_blank")}
          >
            {t("mental-health:completeSurvey.navBtnMentalHealth")}
        </Button>
        <Button
          style={{
            display: "block",
            width: "100%",
            borderColor: "#15A9E1",
            color: "#15A9E1"
          }}
          disabled={!isDisabled}
          onClick={onNext}
          >
            {t("mental-health:completeSurvey.navBtnReturnHome")}
        </Button>
      </>
    )
  );
}

MobileMentalQuestionsNavBtn.defaultProps = {
  isLastQuestion: false,
  isSubmit: false
};

const { string, bool } = PropTypes;

MobileMentalQuestionsNavBtn.propTypes = {
  isLastQuestion: bool,
  isSubmit: bool,
  additionalRoute: string,
};

export default MobileMentalQuestionsNavBtn;
